// Bilingual UI strings — English + Tamil (தமிழ்).
export const translations = {
  en: {
    appName: "CCMC Audit Para Management",
    appShort: "Audit Para System",
    tagline: "Audit Para Resolution & Compliance Portal",

    // Auth
    login: "Login",
    logout: "Logout",
    changePassword: "Change Password",
    mobile: "Mobile / CUG Number",
    password: "Password",
    signIn: "Sign In",
    loginError: "Invalid mobile / CUG number or password.",
    serverError:
      "Cannot reach the server. Make sure the Django backend is running on port 8000.",
    welcome: "Welcome",
    loginBlurb:
      "A governance workflow system for audit para lifecycle management in Tamil Nadu corporations and municipal bodies.",
    loginFeat1: "Bilingual — English & Tamil",
    loginFeat2: "Role-based access control",
    loginFeat3: "Full audit trail & escalation",

    // Nav
    dashboard: "Dashboard",
    paras: "Audit Paras",
    closedParas: "Closed Paras",
    myParas: "My Paras",
    users: "Officers",
    zones: "Zones",
    notifications: "Notifications",
    activityLog: "Activity Log",
    navOverview: "Overview",
    navWorkflow: "Workflow",
    navInsights: "Insights",
    addNewUser: "Add New User",
    departments: "Departments",
    analytics: "Analytics",
    submittedAnswers: "Submitted Answers",
    reviews: "Reviews",

    // Dashboard
    totalParas: "Total Paras",
    pendingParas: "Pending Paras",
    resolvedParas: "Resolved Paras",
    amountPending: "Amount Pending",
    byStatus: "Paras by Status",
    byDepartment: "Paras by Department",
    byZone: "Paras by Zone",

    // Para list / table
    sNo: "S.No",
    year: "Year",
    paraNo: "Para No (பத்தி எண்)",
    department: "Department",
    title: "Title",
    amount: "Amount",
    assignReason: "Assign Reason",
    assign: "Assign",
    assignType: "Assignment",
    assignedTo: "Assigned To",
    status: "Status",
    deadline: "Deadline",
    daysPending: "Days Pending",
    actions: "Actions",
    search: "Search paras...",
    filterStatus: "All Statuses",
    filterFund: "All Funds",
    filterZone: "All Zones",
    mainOffice: "Main Office",
    filterDept: "All Departments",
    noParas: "No audit paras found.",
    uploadPara: "Upload Para",
    addPara: "Add Para",
    bulkUpload: "Bulk Upload",

    // Para detail
    paraDetail: "Para Detail",
    description: "Description (தணிக்க தகட சுருக்ம்)",
    auditRemarks: "Audit Remarks",
    timeline: "Timeline",
    assignmentHistory: "Assignment History",
    evidence: "Evidence / Proof",
    replies: "Replies",
    closure: "Closure",
    zoneStatus: "Zone Status (Combined)",
    submitReply: "Submit Reply",
    explanation: "Explanation",
    uploadEvidence: "Upload Evidence",
    docType: "Document Type",
    file: "File",
    review: "Review",
    accept: "Accept",
    reject: "Reject",
    requestClarification: "Request Clarification",
    closePara: "Close Para",
    reopenPara: "Reopen Para",
    markCompleted: "Mark Completed",
    decision: "Decision",
    remarks: "Remarks",
    cugNumber: "CUG Number",
    escalation: "Escalation",
    notSubmittedYet: "Not submitted yet",
    pendingOfficer: "Pending Officer",
    noOfficerAssigned: "No officer assigned",
    assignmentPending: "AC Assignment Pending",
    pendingSubmission: "Reply Awaited",
    replyPendingFrom: "Replies Pending From",

    // Assignment dialog
    assignPara: "Assign Para",
    individual: "Individual",
    combined: "Combined",
    notAssigned: "Not Assigned",
    selectOfficer: "Select Officer",
    selectDepartment: "Select Department",
    selectZones: "Select Zones",
    reason: "Reason",
    zoneOfficer: "Zone Officer",
    assignOfficer: "Assign Officer",
    zoneOfficerHint:
      "Each zone's AC assigns the para to an officer working in that zone only.",

    // Statuses
    statusPENDING: "Pending",
    statusIN_PROGRESS: "In Progress",
    statusREPLY_SUBMITTED: "Reply Submitted",
    statusSUBMITTED: "Submitted",
    statusRESOLVED: "Resolved",
    statusCLOSED: "Closed",
    statusREOPENED: "Reopened",
    statusCOMPLETED: "Completed",
    statusACCEPTED: "Accepted",
    statusREJECTED: "Rejected",
    statusCLARIFICATION: "Clarification Requested",
    statusActive: "Pending (Active)",
    statusResolvedClosed: "Resolved / Closed",

    // Common
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    close: "Close",
    loading: "Loading...",
    all: "All",
    none: "—",
    confirm: "Confirm",
    addUser: "Add Officer",
    totalUsers: "Total Users",
    fullName: "Full Name",
    role: "Role",
    designation: "Designation",
    zone: "Zone",
    markAllRead: "Mark all as read",
    noNotifications: "No notifications.",
    deptEngineering: "Engineering",
    deptElectrical: "Electrical",
    deptHealth: "Health",
    deptRevenue: "Revenue",
    deptTownPlanning: "Town Planning",
    deptAccounts: "Accounts",
    deptWaterSupply: "Water Supply",
    addZone: "Add Zone",
    editZone: "Edit Zone",
    deleteZone: "Delete Zone",
    code: "Code",
    acOffice: "AC Office",
    deleteConfirm: "Are you sure you want to delete this?",
    zoneProfile: "Zone Profile",
    clear: "Clear",
    selectZone: "Select Zone",
    pendingReview: "Pending Review",
    clarification: "Clarification",
    noRepliesStatus: "No replies in this status.",
    by: "By",
    submitted: "Submitted",
    reviewRemarks: "Review Remarks",
    reviewedBy: "Reviewed by",
    replyToClarification: "Reply to Clarification",
    attachEvidence: "Attach Evidence (optional)",
    clarificationPlaceholder: "Address each point the auditor raised above. Include facts and document references.",
    explanationLetter: "Explanation Letter",
    photograph: "Photograph",
    workOrder: "Work Order",
    billVoucher: "Bill / Voucher",
    measurementBook: "Measurement Book",
    proceedingsCopy: "Proceedings Copy",
    councilResolution: "Council Resolution",
    other: "Other",
    submitting: "Submitting...",
    viewPara: "View Para",
    clarificationSuccess: "Clarification reply submitted.",
    submitError: "Could not submit. Please try again.",
    reviewReply: "Review Reply",
    reviewNow: "Review Now",
    acceptReply: "Accept Reply",
    rejectReply: "Reject Reply",
    clarificationPrompt: "List the specific points the officer must clarify — e.g. 'Provide the work order number for the cement supply', 'Attach the measurement book reference', 'Explain why quantity exceeds the approved estimate'...",
    clarificationHint: "Be specific — the officer will see exactly this text when resubmitting.",
    additionalNotes: "Additional Notes (optional)",
    reviewRemarksLabel: "Review Remarks (optional)",
    reviewRemarksPlaceholder: "Add review notes or feedback...",
    submitReview: "Submit Review",
    reviewSuccess: "Review submitted successfully",
    reviewFail: "Failed to submit review",
    view: "View",
    noEvidence: "No evidence attached to this reply.",
    clarificationRequiredAlert: "Please specify what needs clarification.",
    optional: " (optional)",
    yourZone: "Your Zone",
    yourDept: "Your Department",
    superAdmin: "Super Admin",
    corpAdmin: "Corporation Admin",
    zonalAcLabel: "Zonal Assistant Commissioner (AC) — sets up Zone + zone CUG",
    deptHeadLabel: "Department Head (HOD) — sets up Department + department CUG",
    officerLabel: "Officer (AE / SI / HO)",
    auditorLabel: "Auditor",
    viewerLabel: "Viewer",
    zoneLockedAc: "You can add officers under your zone only. Zone is locked.",
    deptLockedHod: "You can add officers under your department only. Department is locked.",
    mobilePlaceholder: "10-digit mobile",
    fullNamePlaceholder: "As per records",
    selectUserType: "— Select user type —",
    selectZonePrompt: "— Select zone —",
    selectDeptPrompt: "— Select department —",
    cugHint: "creates the permanent admin login",
    cugDesc: "This is the zone's permanent CUG number. Logging in with this number gives admin access for the zone.",
    cugDescDept: "This is the department's permanent CUG number. Logging in with this number gives admin access for the department.",
    existingCugShown: " (Existing CUG shown — edit to change.)",
    designationPlaceholder: "e.g. Assistant Engineer",
    passwordHint: "The user will be asked to change it on first login.",
    createUser: "Create User",
    creating: "Creating…",
    errorRoleRequired: "Please select a user type (role).",
    errorPersonalRequired: "Mobile number and full name are required for this role.",
    errorPasswordRequired: "Initial password is required.",
    errorPasswordLength: "Password must be at least 6 characters long.",
    errorCugRequired: "A CUG number is required when creating an AC / HOD (it sets up the permanent zone/department admin login).",
    personalUserCreated: "Personal user created",
    noPersonalUserCreated: "No personal user created (mobile and name were blank).",
    addDepartment: "Add Department",
    noDepartments: "No departments added yet.",
    edit: "Edit",
    delete: "Delete",
    deleteDeptConfirm: "Are you sure you want to delete the department",
    deleteDeptFail: "Failed to delete department. It may be linked to existing users or paras.",
    activeParas: "Active Paras",
    activeOfficers: "Active Officers",
    avgResolutionRate: "Avg Resolution Rate",
    topPerformer: "Top Performer",
    noClosedParas: "No closed paras yet",
    sortByLabel: "Sort by:",
    sortByRateDesc: "Resolution Rate (desc)",
    sortByTotalDesc: "Total Paras (desc)",
    sortByAvgDaysAsc: "Avg Days to Close (asc)",
    officer: "Officer",
    resolved: "Resolved",
    avgDays: "Avg Days",
    total: "Total",
    resolutionRate: "Resolution Rate",
    noOfficerData: "No officer data yet.",
    changePasswordTitle: "Change Password",
    forcedSub: "For security, set your own password before continuing.",
    forcedDesc: "Your current password is your mobile number. Choose a new private password below.",
    changePasswordDesc: "Update the password for your account. Make sure it is at least 6 characters long and keep it secure.",
    currentPassword: "Current Password",
    currentPasswordPlaceholder: "Enter current password",
    newPassword: "New Password",
    newPasswordPlaceholder: "Enter new password",
    confirmNewPassword: "Confirm New Password",
    confirmNewPasswordPlaceholder: "Confirm new password",
    signOut: "Sign out",
    savePassword: "Save Password",
    saving: "Saving…",
    errorPasswordMatch: "The two new passwords do not match.",
    errorPasswordShort: "New password must be at least 6 characters.",
    passwordChangeSuccess: "Password changed successfully.",
  },

  ta: {
    appName: "சிசிஎம்சி தணிக்கை குறிப்பு மேலாண்மை",
    appShort: "தணிக்கை குறிப்பு அமைப்பு",
    tagline: "தணிக்கை குறிப்பு தீர்வு மற்றும் இணக்க போர்டல்",

    login: "உள்நுழைவு",
    logout: "வெளியேறு",
    changePassword: "கடவுச்சொல்லை மாற்று",
    mobile: "கைபேசி / CUG எண்",
    password: "கடவுச்சொல்",
    signIn: "உள்நுழைக",
    loginError: "தவறான கைபேசி / CUG எண் அல்லது கடவுச்சொல்.",
    serverError:
      "சேவையகத்தை அணுக முடியவில்லை. Django பின்தளம் போர்ட் 8000-ல் இயங்குகிறதா எனப் பார்க்கவும்.",
    welcome: "வரவேற்கிறோம்",
    loginBlurb:
      "தமிழ்நாடு மாநகராட்சிகள் மற்றும் நகராட்சிகளில் தணிக்கை குறிப்பு வாழ்க்கைச் சுழற்சி மேலாண்மைக்கான நிர்வாகப் பணிப்பாய்வு அமைப்பு.",
    loginFeat1: "இருமொழி — ஆங்கிலம் & தமிழ்",
    loginFeat2: "பதவி அடிப்படையிலான அணுகல் கட்டுப்பாடு",
    loginFeat3: "முழு தணிக்கைத் தடம் & மேல்முறையீடு",

    dashboard: "டாஷ்போர்டு",
    paras: "தணிக்கை குறிப்புகள்",
    closedParas: "மூடப்பட்ட குறிப்புகள்",
    myParas: "எனது குறிப்புகள்",
    users: "அலுவலர்கள்",
    zones: "மண்டலங்கள்",
    notifications: "அறிவிப்புகள்",
    activityLog: "செயல்பாட்டு பதிவு",
    navOverview: "மேற்பார்வை",
    navWorkflow: "பணிப்பாய்வு",
    navInsights: "பகுப்பாய்வு",
    addNewUser: "புதிய பயனர் சேர்",
    departments: "துறைகள்",
    analytics: "புள்ளிவிவரங்கள்",
    submittedAnswers: "சமர்ப்பிக்கப்பட்ட பதில்கள்",
    reviews: "மறுஆய்வுகள்",

    totalParas: "மொத்த பத்திகள்",
    pendingParas: "நிலுவையில் உள்ளவை",
    resolvedParas: "தீர்வு செய்யப்பட்டவை",
    amountPending: "நிலுவைத் தொகை",
    byStatus: "நிலை வாரியாக",
    byDepartment: "துறை வாரியாக",
    byZone: "மண்டலம் வாரியாக",

    sNo: "வ.எண்",
    year: "ஆண்டு",
    paraNo: "பத்தி எண்",
    department: "துறை",
    title: "தலைப்பு",
    amount: "தொகை",
    assignReason: "ஒதுக்கீட்டு காரணம்",
    assign: "ஒதுக்கு",
    assignType: "ஒதுக்கீடு",
    assignedTo: "ஒதுக்கப்பட்டது",
    status: "நிலை",
    deadline: "காலக்கெடு",
    daysPending: "நிலுவை நாட்கள்",
    actions: "செயல்கள்",
    search: "குறிப்புகளைத் தேடு...",
    filterStatus: "அனைத்து நிலைகள்",
    filterFund: "அனைத்து நிதிகள்",
    filterZone: "அனைத்து மண்டலங்கள்",
    mainOffice: "தலைமை அலுவலகம்",
    filterDept: "அனைத்து துறைகள்",
    noParas: "தணிக்கை குறிப்புகள் இல்லை.",
    uploadPara: "குறிப்பு பதிவேற்று",
    addPara: "குறிப்பு சேர்",
    bulkUpload: "மொத்த பதிவேற்றம்",

    paraDetail: "குறிப்பு விவரம்",
    description: "தணிக்க தகட சுருக்ம்",
    auditRemarks: "தணிக்கை குறிப்புரை",
    timeline: "செயல்பாட்டு வரிசை",
    assignmentHistory: "ஒதுக்கீட்டு வரலாறு",
    evidence: "ஆதாரம்",
    replies: "பதில்கள்",
    closure: "முடிவுரை",
    zoneStatus: "மண்டல நிலை (இணைந்த)",
    submitReply: "பதில் சமர்ப்பி",
    explanation: "விளக்கம்",
    uploadEvidence: "ஆதாரம் பதிவேற்று",
    docType: "ஆவண வகை",
    file: "கோப்பு",
    review: "மறுஆய்வு",
    accept: "ஏற்கவும்",
    reject: "நிராகரிக்கவும்",
    requestClarification: "விளக்கம் கோரு",
    closePara: "குறிப்பை மூடு",
    reopenPara: "மீண்டும் திற",
    markCompleted: "முடிந்ததாக குறி",
    decision: "முடிவு",
    remarks: "குறிப்புரை",
    cugNumber: "CUG எண்",
    escalation: "மேல்முறையீடு",
    notSubmittedYet: "இன்னும் சமர்ப்பிக்கப்படவில்லை",
    pendingOfficer: "நிலுவையிலுள்ள அலுவலர்",
    noOfficerAssigned: "அலுவலர் இன்னும் ஒதுக்கப்படவில்லை",
    assignmentPending: "ஏசி ஒதுக்கீடு நிலுவையில்",
    pendingSubmission: "பதில் வரவில்லை",
    replyPendingFrom: "பதில் நிலுவையிலுள்ளவர்கள்",

    assignPara: "குறிப்பை ஒதுக்கு",
    individual: "தனிநபர்",
    combined: "இணைந்த",
    notAssigned: "ஒதுக்கப்படவில்லை",
    selectOfficer: "அலுவலரைத் தேர்வுசெய்",
    selectDepartment: "துறையைத் தேர்வுசெய்",
    selectZones: "மண்டலங்களைத் தேர்வுசெய்",
    reason: "காரணம்",
    zoneOfficer: "மண்டல அலுவலர்",
    assignOfficer: "அலுவலரை ஒதுக்கு",
    zoneOfficerHint:
      "ஒவ்வொரு மண்டலத்தின் ஏசி அந்த மண்டலத்தில் பணிபுரியும் அலுவலருக்கு மட்டுமே குறிப்பை ஒதுக்க முடியும்.",

    statusPENDING: "நிலுவையில்",
    statusIN_PROGRESS: "செயல்பாட்டில்",
    statusREPLY_SUBMITTED: "பதில் சமர்ப்பிக்கப்பட்டது",
    statusSUBMITTED: "சமர்ப்பிக்கப்பட்டது",
    statusRESOLVED: "தீர்வு செய்யப்பட்டது",
    statusCLOSED: "மூடப்பட்டது",
    statusREOPENED: "மீண்டும் திறக்கப்பட்டது",
    statusCOMPLETED: "முடிக்கப்பட்டது",
    statusACCEPTED: "ஏற்கப்பட்டது",
    statusREJECTED: "நிராகரிக்கப்பட்டது",
    statusCLARIFICATION: "விளக்கம் கேட்கப்பட்டது",
    statusActive: "நிலுவையில் (செயலில்)",
    statusResolvedClosed: "தீர்வு செய்யப்பட்டது / மூடப்பட்டது",

    save: "சேமி",
    cancel: "ரத்து",
    submit: "சமர்ப்பி",
    close: "மூடு",
    loading: "ஏற்றுகிறது...",
    all: "அனைத்தும்",
    none: "—",
    confirm: "உறுதிசெய்",
    addUser: "அலுவலர் சேர்",
    totalUsers: "மொத்த பயனர்கள்",
    fullName: "முழு பெயர்",
    role: "பதவி",
    designation: "பணி",
    zone: "மண்டலம்",
    markAllRead: "அனைத்தையும் படித்ததாக குறி",
    noNotifications: "அறிவிப்புகள் இல்லை.",
    deptEngineering: "பொறியியல்",
    deptElectrical: "மின் துறை",
    deptHealth: "சுகாதாரம்",
    deptRevenue: "வருவாய்",
    deptTownPlanning: "நகரமைப்பு",
    deptAccounts: "கணக்கு",
    deptWaterSupply: "குடிநீர் வழங்கல்",
    addZone: "மண்டலம் சேர்",
    editZone: "மண்டலம் திருத்து",
    deleteZone: "மண்டலத்தை நீக்கு",
    code: "குறியீடு",
    acOffice: "AC அலுவலகம்",
    deleteConfirm: "இதை நீக்க விரும்புகிறீர்களா?",
    zoneProfile: "மண்டல விவரம்",
    clear: "தெளிவுபடுத்து",
    selectZone: "மண்டலத்தைத் தேர்வுசெய்",
    pendingReview: "மறுஆய்வு நிலுவையில்",
    clarification: "விளக்கம்",
    noRepliesStatus: "இந்த நிலையில் பதில்கள் ஏதுமில்லை.",
    by: "வழங்கியவர்",
    submitted: "சமர்ப்பிக்கப்பட்டது",
    reviewRemarks: "மறுஆய்வுக் குறிப்புகள்",
    reviewedBy: "மறுஆய்வு செய்தவர்",
    replyToClarification: "விளக்கத்திற்குப் பதிலளிக்கவும்",
    attachEvidence: "ஆதாரத்தை இணைக்கவும் (விருப்பத்திற்குரியது)",
    clarificationPlaceholder: "தணிக்கையாளர் மேலே குறிப்பிட்டுள்ள ஒவ்வொரு புள்ளியையும் விளக்கவும். உண்மைகள் மற்றும் ஆவணக் குறிப்புகளைச் சேர்க்கவும்.",
    explanationLetter: "விளக்கக் கடிதம்",
    photograph: "புகைப்படம்",
    workOrder: "பணி ஆணை",
    billVoucher: "ரசீது / சீட்டு",
    measurementBook: "அளவீட்டு புத்தகம்",
    proceedingsCopy: "நடவடிக்கை நகல்",
    councilResolution: "மன்றத் தீர்மானம்",
    other: "இதர",
    submitting: "சமர்ப்பிக்கப்படுகிறது...",
    viewPara: "குறிப்பைக் காண்க",
    clarificationSuccess: "விளக்கப் பதில் சமர்ப்பிக்கப்பட்டது.",
    submitError: "சமர்ப்பிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    reviewReply: "பதிலை மறுஆய்வு செய்க",
    reviewNow: "இப்போது மறுஆய்வு செய்",
    acceptReply: "பதிலை ஏற்கு",
    rejectReply: "பதிலை நிராகரி",
    clarificationPrompt: "அலுவலர் விளக்க வேண்டிய குறிப்பிட்ட புள்ளிகளைப் பட்டியலிடவும் - எ.கா. 'சிமென்ட் விநியோகத்திற்கான பணி ஆணை எண்ணை வழங்கவும்', 'அளவீட்டு புத்தகக் குறிப்பை இணைக்கவும்'...",
    clarificationHint: "குறிப்பிட்டதாக எழுதவும் - மீண்டும் சமர்ப்பிக்கும் போது அலுவலர் இந்த உரையைத் தான் காண்பார்.",
    additionalNotes: "கூடுதல் குறிப்புகள் (விருப்பத்திற்குரியது)",
    reviewRemarksLabel: "மறுஆய்வுக் குறிப்புகள் (விருப்பத்திற்குரியது)",
    reviewRemarksPlaceholder: "மறுஆய்வுக் குறிப்புகள் அல்லது பின்னூட்டங்களைச் சேர்க்கவும்...",
    submitReview: "மறுஆய்வைச் சமர்ப்பி",
    reviewSuccess: "மறுஆய்வு வெற்றிகரமாகச் சமர்ப்பிக்கப்பட்டது",
    reviewFail: "மறுஆய்வைச் சமர்ப்பிக்க முடியவில்லை",
    view: "காண்",
    noEvidence: "ஆதாரங்கள் ஏதும் இணைக்கப்படவில்லை.",
    clarificationRequiredAlert: "விளக்கம் தேவைப்படும் புள்ளிகளைக் குறிப்பிடவும்.",
    optional: " (விருப்பத்திற்குரியது)",
    yourZone: "உங்கள் மண்டலம்",
    yourDept: "உங்கள் துறை",
    superAdmin: "சூப்பர் அட்மின்",
    corpAdmin: "மாநகராட்சி அட்மின்",
    zonalAcLabel: "மண்டல உதவி ஆணையர் (AC) — மண்டலம் + CUG அமைப்பார்",
    deptHeadLabel: "துறைத் தலைவர் (HOD) — துறை + CUG அமைப்பார்",
    officerLabel: "அலுவலர் (AE / SI / HO)",
    auditorLabel: "தணிக்கையாளர்",
    viewerLabel: "பார்வையாளர்",
    zoneLockedAc: "உங்கள் மண்டலத்தின் கீழ் மட்டுமே அதிகாரிகளைச் சேர்க்க முடியும். மண்டலம் பூட்டப்பட்டுள்ளது.",
    deptLockedHod: "உங்கள் துறையின் கீழ் மட்டுமே அதிகாரிகளைச் சேர்க்க முடியும். துறை பூட்டப்பட்டுள்ளது.",
    mobilePlaceholder: "10-இலக்க கைபேசி எண்",
    fullNamePlaceholder: "பதிவேடுகளின்படி",
    selectUserType: "— பயனர் வகையைத் தேர்ந்தெடு —",
    selectZonePrompt: "— மண்டலத்தைத் தேர்ந்தெடு —",
    selectDeptPrompt: "— துறையைத் தேர்ந்தெடு —",
    cugHint: "நிரந்தர நிர்வாக உள்நுழைவை உருவாக்குகிறது",
    cugDesc: "இது மண்டலத்தின் நிரந்தர CUG எண். இந்த எண்ணைக் கொண்டு உள்நுழைவது மண்டலத்திற்கான நிர்வாக அணுகலை வழங்குகிறது.",
    cugDescDept: "இது துறையின் நிரந்தர CUG எண். இந்த எண்ணைக் கொண்டு உள்நுழைவது துறைக்கான நிர்வாக அணுகலை வழங்குகிறது.",
    existingCugShown: " (தற்போதுள்ள CUG காட்டப்பட்டுள்ளது - மாற்ற திருத்தவும்.)",
    designationPlaceholder: "எ.கா. உதவி பொறியாளர்",
    passwordHint: "பயனர் முதல் உள்நுழைவில் அதை மாற்றக் கேட்கப்படுவார்.",
    createUser: "பயனரை உருவாக்கு",
    creating: "உருவாக்கப்படுகிறது...",
    errorRoleRequired: "பயனர் வகையைத் (பதவி) தேர்ந்தெடுக்கவும்.",
    errorPersonalRequired: "இப்பணிக்கு கைபேசி எண் மற்றும் முழு பெயர் தேவை.",
    errorPasswordRequired: "தொடக்க கடவுச்சொல் தேவை.",
    errorPasswordLength: "கடவுச்சொல் குறைந்தது 6 எழுத்துகள் இருக்க வேண்டும்.",
    errorCugRequired: "ஒரு AC / HOD-ஐ உருவாக்கும்போது ஒரு CUG எண் தேவை (அது நிரந்தர மண்டலம்/துறை நிர்வாக உள்நுழைவை அமைக்கிறது).",
    personalUserCreated: "தனிப்பட்ட பயனர் உருவாக்கப்பட்டது",
    noPersonalUserCreated: "தனிப்பட்ட பயனர் உருவாக்கப்படவில்லை (கைபேசி மற்றும் பெயர் காலியாக இருந்தன).",
    addDepartment: "துறை சேர்",
    noDepartments: "துறைகள் இன்னும் சேர்க்கப்படவில்லை.",
    edit: "திருத்து",
    delete: "நீக்கு",
    deleteDeptConfirm: "துறையை நீக்க விரும்புகிறீர்களா?",
    deleteDeptFail: "துறையை நீக்க முடியவில்லை. இது தற்போதுள்ள பயனர்கள் அல்லது தணிக்கை குறிப்புகளுடன் இணைக்கப்பட்டிருக்கலாம்.",
    activeParas: "செயலில் உள்ள குறிப்புகள்",
    activeOfficers: "செயலில் உள்ள அலுவலர்கள்",
    avgResolutionRate: "சராசரி தீர்வு விகிதம்",
    topPerformer: "சிறந்த செயல்பாட்டாளர்",
    noClosedParas: "மூடப்பட்ட குறிப்புகள் இன்னும் இல்லை",
    sortByLabel: "வரிசைப்படுத்து:",
    sortByRateDesc: "தீர்வு விகிதம் (இறங்கு வரிசை)",
    sortByTotalDesc: "மொத்த குறிப்புகள் (இறங்கு வரிசை)",
    sortByAvgDaysAsc: "சராசரி தீர்வு நாட்கள் (ஏறு வரிசை)",
    officer: "அலுவலர்",
    resolved: "தீர்வு செய்யப்பட்டவை",
    avgDays: "சராசரி நாட்கள்",
    total: "மொத்தம்",
    resolutionRate: "தீர்வு விகிதம்",
    noOfficerData: "அலுவலர் தரவு இன்னும் இல்லை.",
    changePasswordTitle: "கடவுச்சொல்லை மாற்று",
    forcedSub: "பாதுகாப்பிற்காக, தொடர்வதற்கு முன் உங்கள் சொந்த கடவுச்சொல்லை அமைக்கவும்.",
    forcedDesc: "உங்கள் தற்போதைய கடவுச்சொல் உங்கள் கைபேசி எண் ஆகும். கீழே புதிய கடவுச்சொல்லைத் தேர்ந்தெடுக்கவும்.",
    changePasswordDesc: "உங்கள் கணக்கிற்கான கடவுச்சொல்லைப் புதுப்பிக்கவும். அது குறைந்தது 6 எழுத்துகள் நீளமாக இருப்பதை உறுதிசெய்து பாதுகாப்பாக வைக்கவும்.",
    currentPassword: "தற்போதைய கடவுச்சொல்",
    currentPasswordPlaceholder: "தற்போதைய கடவுச்சொல்லை உள்ளிடவும்",
    newPassword: "புதிய கடவுச்சொல்",
    newPasswordPlaceholder: "புதிய கடவுச்சொல்லை உள்ளிடவும்",
    confirmNewPassword: "புதிய கடவுச்சொல்லை உறுதிப்படுத்துக",
    confirmNewPasswordPlaceholder: "புதிய கடவுச்சொல்லை உறுதிப்படுத்துக",
    signOut: "வெளியேறு",
    savePassword: "கடவுச்சொல்லைச் சேமி",
    saving: "சேமிக்கப்படுகிறது...",
    errorPasswordMatch: "இரு புதிய கடவுச்சொற்களும் பொருந்தவில்லை.",
    errorPasswordShort: "புதிய கடவுச்சொல் குறைந்தது 6 எழுத்துகள் இருக்க வேண்டும்.",
    passwordChangeSuccess: "கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது.",
  },
};
